import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-54">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center px-4" onClick={onClose} data-id="element-55">
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-56" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="relative bg-navy-800 border border-navy-700 rounded-2xl p-6 md:p-10 max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-57">
            <div className="flex items-center justify-between mb-6" data-id="element-58">
              <h2 className="text-2xl font-bold text-white" data-id="element-59">{title}</h2>
              <button onClick={onClose} className="p-2 rounded-lg hover:bg-navy-700 transition-colors text-lavender-300 hover:text-white" data-id="element-60">
                <XIcon size={20} data-id="element-61" />
              </button>
            </div>
            <div className="text-lavender-200 space-y-4 text-base leading-relaxed" data-id="element-62">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-navy-900 py-8 px-4 border-t border-navy-800" data-id="element-63">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-64">
          <p className="text-lavender-300 text-sm" data-id="element-65">
            &copy; {new Date().getFullYear()} Sueño Profundo. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-6 text-sm" data-id="element-66">
            <button onClick={() => setShowPrivacy(true)} className="text-lavender-300 hover:text-amber-500 transition-colors" data-id="element-67">
              Política de Privacidad
            </button>
            <button onClick={() => setShowTerms(true)} className="text-lavender-300 hover:text-amber-500 transition-colors" data-id="element-68">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-69">
        <p data-id="element-70">
          <strong className="text-white" data-id="element-71">Última actualización:</strong> Abril
          2026
        </p>
        <p data-id="element-72">
          En Sueño Profundo, respetamos tu privacidad y nos comprometemos a
          proteger tus datos personales. Esta política describe cómo
          recopilamos, usamos y protegemos tu información.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-73">
          1. Información que recopilamos
        </h3>
        <p data-id="element-74">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. No
          almacenamos información de tarjetas de crédito en nuestros servidores.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-75">
          2. Uso de la información
        </h3>
        <p data-id="element-76">
          Tu información se utiliza exclusivamente para: procesar tu pedido,
          enviarte el producto digital adquirido y comunicarnos contigo en caso
          de ser necesario respecto a tu compra.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-77">
          3. Protección de datos
        </h3>
        <p data-id="element-78">
          Utilizamos medidas de seguridad estándar de la industria para proteger
          tu información personal. Todas las transacciones se procesan a través
          de plataformas de pago seguras con encriptación SSL.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-79">4. Terceros</h3>
        <p data-id="element-80">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. Esto no incluye a terceros de confianza que nos ayudan a
          operar nuestro sitio web o a procesar pagos, siempre que dichas partes
          acuerden mantener esta información confidencial.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-81">5. Cookies</h3>
        <p data-id="element-82">
          Podemos utilizar cookies para mejorar tu experiencia en nuestro sitio.
          Puedes configurar tu navegador para rechazar cookies, aunque esto
          podría afectar algunas funcionalidades.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-83">
        <p data-id="element-84">
          <strong className="text-white" data-id="element-85">Última actualización:</strong> Abril
          2026
        </p>
        <p data-id="element-86">
          Al adquirir el producto "Sueño Profundo (Sin Pastillas)", aceptas los
          siguientes términos y condiciones.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-87">
          1. Producto digital
        </h3>
        <p data-id="element-88">
          Este es un producto digital en formato PDF. Tras completar el pago,
          recibirás acceso instantáneo para descargar el material. Debido a la
          naturaleza digital del producto, no se aceptan devoluciones una vez
          descargado.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-89">2. Uso personal</h3>
        <p data-id="element-90">
          El contenido adquirido es para uso personal y exclusivo del comprador.
          Queda prohibida la reproducción, distribución o reventa total o
          parcial del material sin autorización expresa.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-91">
          3. Descargo de responsabilidad médica
        </h3>
        <p data-id="element-92">
          El contenido de este producto es informativo y educativo. No sustituye
          el consejo médico profesional. Si tienes condiciones médicas
          diagnosticadas como apnea del sueño u otros trastornos, consulta a tu
          médico antes de implementar cualquier protocolo.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-93">4. Resultados</h3>
        <p data-id="element-94">
          Los resultados pueden variar de persona a persona. Las experiencias
          descritas en el material son ilustrativas y no garantizan resultados
          idénticos para todos los usuarios.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-95">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-96">
          Todo el contenido, incluyendo textos, gráficos y metodologías, está
          protegido por derechos de autor. El uso no autorizado constituye una
          violación de las leyes de propiedad intelectual aplicables.
        </p>
      </Modal>
    </>;
}